import { useRecords } from '../../lib/useRecords';
import { describeForm } from '../../lib/formText';
import { SAMPLE_DATA } from '../../lib/sample';
import { useClaudeTasks } from './useClaudeTasks';

/** What the user is told after adding a record: with real data it goes to Claude, who writes it into the vault */
export const addedText = (noun: string) =>
  SAMPLE_DATA
    ? `${noun} added for now (sample data).`
    : `Sent to Claude. It adds the ${noun.toLowerCase()} to the vault within a minute or two. Follow it under Reminders & Calendar → Claude's Tasks.`;

/**
 * A list read from the vault (customers, agents, carriers) whose "add" hands the new record to Claude as a task,
 * because the vault is written by Claude only. With sample data on, it is kept in the browser instead.
 */
export function useVaultRecords<T extends { name: string }>(key: string, noun: string, load: () => Promise<T[]>) {
  const records = useRecords<T>(key, [], load);
  const tasks = useClaudeTasks();
  const add = async (item: T) => {
    if (SAMPLE_DATA) return records.add(item);
    const { id: _id, ...details } = item as T & { id?: string };
    await tasks.add({
      task: `Add this new ${noun.toLowerCase()} to the vault, as the Data README and the ${noun.toLowerCase()} notes already there do. Do not contact anyone. Fill only what is given below.\n${describeForm(details)}`,
    });
  };
  return { ...records, add };
}
